import { gql } from '@apollo/client';

export const BankAccountWithInstitutionAndOwner = gql`
  fragment BankAccountWithInstitutionAndOwner on BankAccountWithInstitutionAndOwner {
    id
    accountNumber
    currencyCode
    name
    bankInstitutionId
    plaidAccountId
    tellerAccountId
    retrievedAt
    current
    available
    conversionRate
    routingNumber
    institutionName
    bankInstitutionKey
    organizationId
    ownerType
    ownerName
    connectionProviderName
    connectionProviderAccountMask
  }
`;

export const GET_INSTITUTION_AND_CONNECTION_DETAILS_FOR_BORROWER = gql`
  query GetInstitutionAndConnectionDetailsForBorrowerId($borrowerId: UUID!) {
    institutionAndConnectionDetailsForBorrower(borrowerId: $borrowerId) {
      creditFacilityId
      creditFacilitySlug
      creditFacilityName
      organizations {
        id
        name
        slug
        type
      }
      tellerBankInstitutionId
      tellerBankInstitutionName
      tellerBankInstitutionKey
      tellerItemId
      tellerAccountId
      tellerAccountName
      tellerAccountMask
      plaidBankInstitutionId
      plaidBankInstitutionName
      plaidBankInstitutionKey
      plaidItemId
      plaidAccountId
      plaidAccountName
      plaidAccountMask
    }
  }
`;

export const GET_INSTITUTION_AND_CONNECTION_DETAILS_FOR_IMPLEMENTATION = gql`
  query GetInstitutionAndConnectionDetailsForImplementationId(
    $implementationId: UUID!
  ) {
    institutionAndConnectionDetailsForImplementation(
      implementationId: $implementationId
    ) {
      creditFacilityId
      creditFacilitySlug
      creditFacilityName
      organizations {
        id
        name
        slug
        type
      }
      tellerBankInstitutionId
      tellerBankInstitutionName
      tellerBankInstitutionKey
      tellerItemId
      tellerAccountId
      tellerAccountName
      tellerAccountMask
      plaidBankInstitutionId
      plaidBankInstitutionName
      plaidBankInstitutionKey
      plaidItemId
      plaidAccountId
      plaidAccountName
      plaidAccountMask
    }
  }
`;

export const GET_BANK_ACCOUNTS_BY_CREDIT_FACILITY_ID = gql`
  query GetBankAccountsByCreditFacilityId(
    $organizationId: UUID!
    $creditFacilityId: UUID!
  ) {
    bankAccountsWithDesignationAndOwner(
      organizationId: $organizationId
      creditFacilityId: $creditFacilityId
    ) {
      id
      accountNumber
      currencyCode
      name
      bankInstitutionId
      plaidAccountId
      tellerAccountId
      retrievedAt
      current
      available
      conversionRate
      routingNumber
      institutionName
      bankInstitutionKey
      organizationId
      ownerType
      accountType
      creditFacilityId
      ownerName
      connectionProviderName
      connectionProviderAccountMask
    }
  }
`;

// ***** MOVING, DO NOT CALL ON CORE SIDE JUST YET

export const GET_ALL_BANK_INSTITUTIONS = gql`
  query GetAllBankInstitutions {
    allBankInstitutions {
      id
      name
      bankInstitutionKey
      tellerInstitutionId
      plaidInstitutionId
    }
  }
`;

export const GET_BANK_ACCOUNTS_WITH_INSTITUTION_AND_OWNER_BY_IMPLEMENTATION_ID = gql`
  query getBankAccountsWithInstitutionAndOwnerByImplementationId(
    $implementationId: UUID!
    $maskSensitiveInfo: Boolean
  ) {
    implementation(implementationId: $implementationId) {
      bankAccountsWithInstitutionAndOwner(
        maskSensitiveInfo: $maskSensitiveInfo
      ) {
        ...BankAccountWithInstitutionAndOwner
      }
    }
  }
`;

// @makarand-fx: add currencyCode to the mutation
// to allow for setting currency-code during account creation
export const ADD_BANK_ACCOUNT = gql`
  mutation AddBankAccount(
    $bankInstitutionId: UUID!
    $accountName: String!
    $accountNumber: String!
    $routingNumber: String!
    $implementationId: UUID!
    $ownerId: UUID!
    $plaidAccountId: String
    $tellerAccountId: String
  ) {
    addBankAccount(
      bankInstitutionId: $bankInstitutionId
      accountName: $accountName
      accountNumber: $accountNumber
      routingNumber: $routingNumber
      implementationId: $implementationId
      ownerId: $ownerId
      plaidAccountId: $plaidAccountId
      tellerAccountId: $tellerAccountId
    ) {
      response
    }
  }
`;

// @makarand-fx: add currencyCode to the mutation
// to allow for setting currency-code during account editing
export const EDIT_BANK_ACCOUNT = gql`
  mutation EditBankAccount(
    $bankAccountId: UUID!
    $accountName: String!
    $ownerId: UUID!
    $plaidAccountId: String
    $tellerAccountId: String
  ) {
    editBankAccount(
      bankAccountId: $bankAccountId
      accountName: $accountName
      ownerId: $ownerId
      plaidAccountId: $plaidAccountId
      tellerAccountId: $tellerAccountId
    ) {
      response
    }
  }
`;

export const DEACTIVATE_BANK_ACCOUNT = gql`
  mutation DeactivateBankAccount($bankAccountId: UUID!) {
    deactivateBankAccount(bankAccountId: $bankAccountId) {
      response
    }
  }
`;
